export const SimpleSoulmateLogEvent = {
  // [맛 소울메이트 랜딩] 화면 진입
  SIMPLE_SOULMATE_LANDING_SCREEN_VIEWED: {
    amp: 'Simple Soulmate Landing - Screen Viewed',
    ga: 'simple_soulmate_landing_screen_viewed',
  },

  // [맛 소울메이트 랜딩] 시작 버튼 클릭
  SIMPLE_SOULMATE_LANDING_START_BUTTON_CLICKED: {
    amp: 'Simple Soulmate Landing - Start Button Clicked',
    ga: 'simple_soulmate_landing_start_button_clicked',
  },

  // [맛 소울메이트 랜딩] MBTI 버튼 클릭
  SIMPLE_SOULMATE_LANDING_MBTI_BUTTON_CLICKED: {
    amp: 'Simple Soulmate Landing - Mbti Button Clicked',
    ga: 'simple_soulmate_landing_mbti_button_clicked',
  },

  // [맛 소울메이트 메인] 화면 진입
  SIMPLE_SOULMATE_MAIN_SCREEN_VIEWED: {
    amp: 'Simple Soulmate Main - Screen Viewed',
    ga: 'simple_soulmate_main_screen_viewed',
  },

  // [맛 소울메이트 메인] 룰렛 클릭
  SIMPLE_SOULMATE_MAIN_ROULETTE_BUTTON_CLICKED: {
    amp: 'Simple Soulmate Main - Roulette Button Clicked',
    ga: 'simple_soulmate_main_roulette_button_clicked',
  },

  // [맛 소울메이트 메인] 공유 버튼 클릭
  SIMPLE_SOULMATE_MAIN_SHARE_BUTTON_CLICKED: {
    amp: 'Simple Soulmate Main - Share Button Clicked',
    ga: 'simple_soulmate_main_share_button_clicked',
  },

  // [맛 소울메이트 메인] 앱 버튼 클릭
  SIMPLE_SOULMATE_MAIN_APP_BUTTON_CLICKED: {
    amp: 'Simple Soulmate Main - App Button Clicked',
    ga: 'simple_soulmate_main_app_button_clicked',
  },

  // [맛 소울메이트 만들기] 화면 진입
  SIMPLE_SOULMATE_CREATE_SCREEN_VIEWED: {
    amp: 'Simple Soulmate Create - Screen Viewed',
    ga: 'simple_soulmate_create_screen_viewed',
  },

  // [맛 소울메이트 만들기] 완료 버튼 클릭
  SIMPLE_SOULMATE_CREATE_SUBMIT_BUTTON_CLICKED: {
    amp: 'Simple Soulmate Create - Submit Button Viewed',
    ga: 'simple_soulmate_create_submit_button_clicked',
  },

  // [맛 소울메이트 로딩] 화면 진입
  SIMPLE_SOULMATE_LOADING_SCREEN_VIEWED: {
    amp: 'Simple Soulmate Loading - Screen Viewed',
    ga: 'simple_soulmate_loading_screen_viewed',
  },

  // [맛 소울메이트 로딩] 펜딩 결과 화면 노출
  SIMPLE_SOULMATE_LOADING_PENDING_RESULT_VIEWED: {
    amp: 'Simple Soulmate Loading - Pending Result Viewed',
    ga: 'simple_soulmate_loading_pending_result_viewed',
  },

  // [맛 소울메이트 로딩] 쿠팡 버튼 클릭
  SIMPLE_SOULMATE_LOADING_AD_BUTTON_CLICKED: {
    amp: 'Simple Soulmate Loading - Ad Button Clicked',
    ga: 'simple_soulmate_loading_ad_button_clicked',
  },

  // [맛 소울메이트 결과] 화면 진입
  SIMPLE_SOULMATE_RESULT_SCREEN_VIEWED: {
    amp: 'Simple Soulmate Result - Screen Viewed',
    ga: 'simple_soulmate_result_screen_viewed',
  },

  // [맛 소울메이트 결과] 모든 순위 보기 클릭
  SIMPLE_SOULMATE_RESULT_SHOW_ALL_RANK_CLICKED: {
    amp: 'Simple Soulmate Result - Show All Rank Clicked',
    ga: 'simple_soulmate_result_show_all_rank_clicked',
  },

  // [맛 소울메이트 결과] 성별 별 순위 보기 클릭
  SIMPLE_SOULMATE_RESULT_GENDER_RANK_BUTTON_CLICKED: {
    amp: 'Simple Soulmate Result - Gender Rank Button Clicked',
    ga: 'simple_soulmate_result_gender_rank_button_clicked',
  },

  // [맛 소울메이트 결과] 공유 버튼 클릭
  SIMPLE_SOULMATE_RESULT_SHARE_BUTTON_CLICKED: {
    amp: 'Simple Soulmate Result - Share Button Clicked',
    ga: 'simple_soulmate_result_share_button_clicked',
  },

  // [맛 소울메이트 결과] 플로팅 버튼 클릭
  SIMPLE_SOULMATE_RESULT_FLOATING_BUTTON_CLICKED: {
    amp: 'Simple Soulmate Result - Floating Button Clicked',
    ga: 'simple_soulmate_result_floating_button_clicked',
  },

  // [맛 소울메이트 랭킹] 화면 진입
  SIMPLE_SOULMATE_RANK_SCREEN_VIEWED: {
    amp: 'Simple Soulmate Rank - Screen Viewed',
    ga: 'simple_soulmate_rank_screen_viewed',
  },

  // [맛 소울메이트 랭킹] 모두 보기 클릭
  SIMPLE_SOULMATE_RANK_SHOW_ALL_BUTTON_CLICKED: {
    amp: 'Simple Soulmate Rank - Show All Button Clicked',
    ga: 'simple_soulmate_rank_show_all_button_clicked',
  },

  // [맛 소울메이트 랭킹] MBTI 별 순위 보기 클릭
  SIMPLE_SOULMATE_RANK_MBTI_BUTTON_CLICKED: {
    amp: 'Simple Soulmate Rank - Mbti Rank Button Clicked',
    ga: 'simple_soulmate_rank_mbti_button_clicked',
  },

  // [맛 소울메이트 랭킹 MBTI 선택] 화면 진입
  SIMPLE_SOULMATE_RANK_MBTI_SELECT_SCREEN_VIEWED: {
    amp: 'Simple Soulmate Rank Mbti Select - Screen Viewed',
    ga: 'simple_soulmate_rank_mbti_select_screen_viewed',
  },

  // [맛 소울메이트 랭킹 MBTI 선택] MBTI 클릭
  SIMPLE_SOULMATE_RANK_MBTI_SELECT_CLICKED: {
    amp: 'Simple Soulmate Rank Mbti Select - Mbti Clicked',
    ga: 'simple_soulmate_rank_mbti_select_clicked',
  },

  // [맛 소울메이트 랭킹 MBTI 결과] 화면 진입
  SIMPLE_SOULMATE_RANK_MBTI_RESULT_SCREEN_VIEWED: {
    amp: 'Simple Soulmate Rank Mbti Result - Screen Viewed',
    ga: 'simple_soulmate_rank_mbti_result_screen_viewed',
  },

  // [맛 소울메이트 랭킹 MBTI 결과] 공유 버튼 클릭
  SIMPLE_SOULMATE_RANK_MBTI_RESULT_SHARE_BUTTON_CLICKED: {
    amp: 'Simple Soulmate Rank Mbti Result - Share Button Clicked',
    ga: 'simple_soulmate_rank_mbti_result_share_button_clicked',
  },

  // [소울메이트 앱랜딩] 화면 진입
  SOULMATE_LANDING_SCREEN_VIEWED: {
    amp: 'Soulmate Landing - Screen Viewed',
    ga: 'soulmate_landing_screen_viewed',
  },

  // [소울메이트 앱랜딩] 공유 버튼 클릭
  SOULMATE_LANDING_SHARE_BUTTON_CLICKED: {
    amp: 'Soulmate Landing - Share Button Clicked',
    ga: 'soulmate_landing_share_button_clicked',
  },
}
